import React, { useContext, useState } from 'react';
import { Link } from 'gatsby';
import { GlobalSiteDataContext } from '../../context';
import DiscountModal from '../forms/discount/DiscountModal';
import { formatPromoText } from './utils/bannerFormatting';

const SpecialsBanner = ({ textColor = 'milan-text-white', className = '', supportsLineBreak = false }) => {
    const siteData = useContext(GlobalSiteDataContext);
    const { isBuilderDataLoading } = siteData;
    const specialsBannerText = siteData?.promotionalBannersTextData?.specialsBanner;

    // The banner renders in the case entered in Builder — no text-transform here
    // — so marketing controls ALL CAPS vs. Mixed Case from the Promotions Banners
    // model. supportsLineBreak is set per placement; formatPromoText only renders
    // a break when the placement supports two lines AND the copy contains a (br).
    const specialsText = (
        <div className="text-center">
            {!isBuilderDataLoading ? formatPromoText(specialsBannerText, { supportsLineBreak }) : <></>}
        </div>
    );

    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Link to="/specials/" className={`specials-banner ${textColor} ${className}`}>
                {specialsText}
            </Link>

            {/* Discount Banner Lead Flow Experiment */}
            {/* In this experiment, when a user clicks on the specials text, instead of being redirected to the /specials endpoint, it will open a modal with the consultation form */}
            <a
                className={`specials-banner ${textColor} specials-banner-modal-link`}
                onClick={() => setShowModal(true)}
                style={{ cursor: 'pointer', display: 'none' }}
            >
                {specialsText}
            </a>

            <DiscountModal show={showModal} onClose={() => setShowModal(false)} siteData={siteData} />
        </>
    );
};

export default SpecialsBanner;
